const ShowInformationContentTitle = () => {
  return (
    <div className="flex flex-col w-20 text-Body2-M text-gray-90">
      <span>전시 종류</span>
      <span className="mt-2">장소</span>
      <span className="mt-2">전시 지역</span>
      <span className="mt-2">전시 문의</span>
      <span className="mt-2">전시 소개</span>
    </div>
  );
};

export default ShowInformationContentTitle;
